import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import MobileMenu from "../components/mobile-menu/MobileMenu";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import MobileBtn from "../components/mobile-menu/MobileBtn";

import logo from "../assets/img/vivenLogo.png";
const Menu = () => {
  const triggerSearch = () => {
    const offcanvasMobileMenu = document.querySelector(".search_icon_inr");
    offcanvasMobileMenu.classList.toggle("active");
  };

  return (
    <div className="menu_area">
      {/* Start: header navigation */}
      <div className="navigation">
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="container"
        >
          <div style={{ paddingBottom: "110px" }} className="logo">
            <Link to={process.env.PUBLIC_URL + "/"}>
              <img style={{ maxWidth: "200px" }} src={logo} alt="" />
            </Link>
          </div>

          <div className="meun_wrp">
            <Navbar expand="lg" sticky="top" id="navigation">
              <Nav className="mr-auto">
                <ul>
                  <li className="active">
                    <Link to={"/"}>Home </Link>
                  </li>
                  <li className="has-sub">
                    <Link
                      to={{
                        pathname: "/", // Your home page
                        search: "?scrollTo=team-section", // Query parameter with the anchor point
                      }}
                    >
                      About us
                    </Link>
                  </li>
                  <li className="has-sub">
                    <Link to="/services">Services </Link>
                  </li>

                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </Nav>
            </Navbar>
          </div>

          {/* Mobile Menu */}

          <MobileBtn />

          <MobileMenu />

          {/* End:  Mobile Menu */}

          {/* Start: Cart  */}

          {/* End: Cart  */}
        </div>
        {/* container */}
      </div>
      {/* End: header navigation */}
    </div>
  );
};

export default Menu;
